import { render, staticRenderFns } from "./WeedoTrustCalculatorAdmin.vue?vue&type=template&id=48a5cd7a&scoped=true&"
import script from "./WeedoTrustCalculatorAdmin.vue?vue&type=script&lang=js&"
export * from "./WeedoTrustCalculatorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./WeedoTrustCalculatorAdmin.vue?vue&type=style&index=0&id=48a5cd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5cd7a",
  null
  
)

export default component.exports